import Phaser from 'phaser';

type Variant = 'default' | 'red' | 'green' | 'outline';
type Size = 'M' | 'L' | 'XL';

const colorsMap: Record<Variant, number> = {
    default: 0x778da9,
    red: 0xe63946,
    green: 0x78ad40,
    outline: 0xFFFFFF
};
const sizeMap: Record<Size, { fontSize: number; padding: number; }> = {
    M: { fontSize: 48, padding: 32 },
    L: { fontSize: 64, padding: 48 },
    XL: { fontSize: 92, padding: 48 }
};

export default class Button extends Phaser.GameObjects.Container {
    private text: Phaser.GameObjects.Text;
    private graphics: Phaser.GameObjects.Graphics;

    constructor(scene: Phaser.Scene, title: string, onClick?: () => void, variant: Variant = 'default', size: Size = 'M') {
        super(scene);
        scene.add.existing(this);
        const padding = sizeMap[size].padding;

        this.text = scene.add.text(0, 0, title, {
            fontSize: sizeMap[size].fontSize,
            color: '#FFF',
            fontFamily: 'Trebuchet MS'
        }).setDepth(5).setOrigin(0.5).setShadow(-1, 1, '#000', 1);
        this.setSize(this.text.width + padding, this.text.height + padding);

        const width = this.text.width + padding;
        const height = this.text.height + padding;
        this.graphics = this.scene.add.graphics()
            .fillStyle(colorsMap[variant], 1)
            .fillRoundedRect(
                this.text.x - (this.text.width + padding) / 2,
                this.text.y - (this.text.height + padding) / 2,
                width,
                height,
                padding
            );

        this.add([this.graphics, this.text]);
        this.setInteractive();

        switch (variant) {
            case 'outline':
                this.graphics.setDefaultStyles({ lineStyle: { color: 0x000, width: 4 } });
                this.graphics.strokeRoundedRect(-width/2, -height/2, width, height, padding);
                this.text.setColor('#000');
                break;
        }

        this.on('pointerover', () => {
            this.setScale(this.scale * 1.2);
        });
        this.on('pointerout', () => {
            this.setScale(this.scale / 1.2);
        });
        this.on('pointerdown', () => {
            onClick?.();
        });
    }
}